<script setup lang="ts">
import { ref, watch } from 'vue'
import { FilterField, TableField } from "../../../../../components/table/table";
import { Permission } from '../../../../../types/auth'
import ListTemplate from "../../../../../components/ui/common/ListTemplate.vue";
import CustomerAddressForm from './CustomerAddressForm.vue';

const props = withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
  permissions?: Permission[]
  data?: any,
  customer?: any | null
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = '/clients/revenue/master-data/customers/address-'
const title = 'Addresses'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const fields: TableField[] = [
  { name: 'full_address', caption: 'Address', sortable: true, fieldType: 'text' },
  { name: 'primary', caption: 'Primary', sortable: true, fieldType: 'boolean' },
  { name: 'apartment', caption: 'Apartment', sortable: true, fieldType: 'text' },
  { name: 'building', caption: 'Building', sortable: true, fieldType: 'text' },
  { name: 'road', caption: 'Road', sortable: true, fieldType: 'text' },
  { name: 'city', caption: 'City', sortable: true, fieldType: 'text' },
  { name: 'state', caption: 'State', sortable: true, fieldType: 'text' },
  { name: 'country', caption: 'Country', sortable: true, fieldType: 'text' },
  { name: 'active', caption: 'active', sortable: false, fieldType: 'status' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data : any) => {
  selectedData.value = data
}

const rows = ref<any[]>(props.data)

const handleSave = (data: any) => {
  rows.value = data
  refreshData.value = !refreshData.value
}

watch(() => props.customer, () => {
  if (props.customer && props.customer.uid) {
    refreshData.value = !refreshData.value
  }
}, { immediate: true })


watch(() => props.data, () => {
  rows.value = props.data
}, { immediate: true })

</script>

<template>
  <ListTemplate :custom-url = "endPoint + 'get'" :title = "title" :fields = "fields" :actions = "[]" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" :ignore-permissions="true"
  @data="handleData" :show-header="showHeader" :show-quick-tour="false" :show-title="showTitle" :showQuickView="false" 
  :showPagination="true" :allowDisable="false" :data="rows" :require-params="true" :params="[{field: 'uid', value: customer?.uid, required: true}]">
  <template #form-view>
    <CustomerAddressForm
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="handleSave"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>